import PropertyDescriptor from '../../designer/utils/PropertyDescriptor';
import BordableProperty from './BordableProperty';

export default class Model extends BordableProperty {

    text = new PropertyDescriptor("文本框", '文本', "文本", "text", "#anticon-dongtaiwenben", {
        placeholder: '请输入文本',
        catalogIndex: 30,
    });

    fontSize = new PropertyDescriptor(18, '大小', "文本", "double", "#anticon-zitidaxiao", {
        minValue: 0,
    });

    fontColor = new PropertyDescriptor('#000000', '颜色', "文本", "color", "#anticon-beijingyanse", {
    });

    isBold = new PropertyDescriptor(false, '粗体', "文本", "bool", "#anticon-bold1", {
    });

    verticalAlignment = new PropertyDescriptor("center", '垂直对齐', "文本", "enum", "#anticon-chuizhijuzhongduiqi1", {
        values: [
            new PropertyDescriptor("flex-start", '上', "垂直对齐", "string"),
            new PropertyDescriptor("center", '中', "垂直对齐", "string"),
            new PropertyDescriptor("flex-end", '下', "垂直对齐", "string"),
        ]
    });

    horizontalAlignment = new PropertyDescriptor("center", '水平对齐', "文本", "enum", "#anticon-chuizhijuzhongduiqi1", {
        values: [
            new PropertyDescriptor("flex-start", '左', "垂直对齐", "string"),
            new PropertyDescriptor("center", '中', "垂直对齐", "string"),
            new PropertyDescriptor("flex-end", '右', "垂直对齐", "string"),
        ]
    });

    toStyle() {

        return {
            ...super.toStyle(),
            fontSize: this.fontSize,
            fontWeight: this.isBold ? 'bold' : 'normal',
            color: this.fontColor,
            display: 'flex',
            flexDirection: 'row',
            textAlign: this.horizontalAlignment === "center" ? "center" : (this.horizontalAlignment === "flex-start" ? "left" : "right"),
            alignItems: this.verticalAlignment,
            justifyContent: this.horizontalAlignment,
        }
    }
}
